import { cn } from '../../lib/utils';

export interface IconProps {
  src: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
}

const sizeClasses = {
  xs: 'h-3 w-3',
  sm: 'h-4 w-4',
  md: 'h-5 w-5',
  lg: 'h-6 w-6',
  xl: 'h-8 w-8',
};

function Icon({ src, size = 'md', className }: IconProps) {
  // Quoting the URL value prevents breakage when data URIs contain
  // unescaped single quotes (e.g. fill='currentColor' in SVGs).
  const maskUrl = `url("${src}")`;
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block shrink-0', sizeClasses[size], className)}
      style={{
        backgroundColor: 'currentColor',
        maskImage: maskUrl,
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskImage: maskUrl,
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
      }}
    />
  );
}

export { Icon };
